import * as z from "zod/v4";

export const getReturnsTiktokIntegration = {
  name: "getReturnsTiktokIntegration" as const,
  input: z.object({}),
  output: z.object({ exists: z.boolean() }),
};
